var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("span", [
    _c("input", {
      attrs: {
        type: "hidden",
        name: _vm.name
      },
      domProps: {
        value: _vm.value
      }
    }),
    _vm._v(" "),
    _c(
      "input",
      _vm._g(
        _vm._b(
          {
            ref: "visibleInput",
            staticClass: "visible_input",
            attrs: {
              type: "text"
            },
            on: {
              change: _vm.setUnixTimestamp
            }
          },
          "input",
          _vm.$attrs,
          false
        ),
        _vm.$listeners
      )
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }